import { render } from "./OAuthCallback.vue?vue&type=template&id=cb01ebf0&scoped=true"
import script from "./OAuthCallback.vue?vue&type=script&lang=js"
export * from "./OAuthCallback.vue?vue&type=script&lang=js"

import "./OAuthCallback.vue?vue&type=style&index=0&id=cb01ebf0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb01ebf0"]])

export default __exports__